import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import LogRocket from "logrocket";

import { createBrowserHistory } from "history";
import reducers from "../redux/reducers";
import thunk from "redux-thunk";

const history = createBrowserHistory();
const middlewares = [thunk];

if (process.env.REACT_APP_LOGROCKET_APP_ID) {
  middlewares.push(
    LogRocket.reduxMiddleware({
      actionSanitizer: (action) =>
        action.type === "CANVAS_SET_VALUE"
          ? { ...action, value: "[Fabric canvas]" }
          : action,
      stateSanitizer: (state) => ({
        ...state,
        Canvas: state.Canvas
          ? {
              ...state.Canvas,
              canvas: "[Fabric canvas]",
            }
          : state.Canvas,
      }),
    })
  );
}

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

const store = createStore(
  combineReducers({
    ...reducers,
  }),
  composeEnhancers(applyMiddleware(...middlewares))
);
// sagaMiddleware.run(rootSaga);
export { store, history };
